import { gql } from '@apollo/client'
import { useState, useEffect, useRef, Fragment } from 'react'
import { Alert, Input } from 'reactstrap'
import { CUSTOM_SELECT_LIST_QUERY } from '../../graphql'
import { handleGraphQLErrors } from '../../utils'
import Spinner from '../Spinner/Spinner'
import CustomSelectClearButton from './CustomSelectClearButton'

export const CUSTOM_SELECT_LIST = gql(CUSTOM_SELECT_LIST_QUERY)

export default function CustomSelectList(props) {
  console.log('CustomSelectList rendered: ', props)
  const { handleChange, name, multiple, modelName, entityName, defaultValue, allOption, allOptionSelected, blankOption, uniqueOptionCallback, controlledInput, dataCy } = props

  const [items, setItems] = useState()
  const inputRef = useRef(null)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        let { data, errors } = await window.apolloClient.query({ query: CUSTOM_SELECT_LIST, variables: { modelName: modelName, entityName: entityName }, fetchPolicy: 'cache-first' })
        if (data.customSelectList) {
          const menuItems = []
          if ((!multiple || allOption) && !blankOption) {
            menuItems.push(<option key={0} value='' selected={allOptionSelected}>All</option>)
          }
          if (blankOption) {
            menuItems.push(<option key={0} value=''></option>)
          }
          let dataCopy = JSON.parse(JSON.stringify(data.customSelectList))
          if (uniqueOptionCallback) {
            dataCopy = uniqueOptionCallback(dataCopy)
          }
          for (let item of dataCopy) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        console.log(err)
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [modelName, entityName, items, multiple, allOption, allOptionSelected, uniqueOptionCallback, blankOption])

  function clearSelections() {
    console.log('CustomSelectList.clearSelections: inputRef: ', inputRef)
    inputRef.current.selectedIndex = -1
  }

  let clearButton = null
  if (multiple) {
    clearButton = <CustomSelectClearButton inputName={name} handleChange={handleChange} clearSelections={clearSelections} />
  }

  if (graphQLErrors.length > 0) {
    return <Alert color='danger'>{graphQLErrors[0].message}</Alert>
  } else if (controlledInput && items) {
    return (
      <Fragment>
        <Input innerRef={inputRef} data-cy={dataCy} style={{ width: 'auto', marginRight: '5px' }} type="select" bsSize="sm" multiple={multiple} value={defaultValue} name={name} onChange={handleChange}>
          {items}
        </Input>
        {clearButton}
      </Fragment>
    )
  }
  else if (items) {
    return (
      <Fragment>
        <Input innerRef={inputRef} data-cy={dataCy} style={{ width: 'auto', marginRight: '5px' }} type="select" bsSize="sm" multiple={multiple} defaultValue={defaultValue} name={name} onChange={handleChange}>
          {items}
        </Input>
        {clearButton}
      </Fragment>
    )
  } else {
    return <Spinner />
  }
}
